module.exports = __webpack_public_path__ + "static/img/logo-en.db9b0dec.png";